<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <page-header>
      {{ $t('SpecialOpeningTimes') }}
      <template #action>
        <primary-button
          icon="mdi-plus"
          text="AddTimeRule"
          @click="editingObject=null;showDialog=true"
        />
      </template>
    </page-header>
    <loading-provider
      :loading="loading"
      class="mt-4"
    >
      <div style="display: grid;grid-template-columns: 1fr;grid-gap: 4px">
        <v-card
          v-for="r in list"
          :key="r.id"
          class="px-4 py-3 pt-4
"
          elevation="0"
          @click="edit(r)"
        >
          <div class="d-flex">
            <div class="text-body-1 mr-2 font-weight-black">
              {{ r.date }}
            </div>
            <v-chip
              :color="r.active ? 'success' : 'grey'"
              class="mr-2"
              small
              text-color="white"
            >
              {{ r.active ? '已激活' : '未激活' }}
            </v-chip>
            <v-spacer />
            <v-btn
              class="ml-2"
              color="grey lighten-4"
              elevation="0"
              small
              @click.stop="remove(r)"
            >
              {{ $t('delete') }}
            </v-btn>
          </div>
          <div>
            <div class="text-body-1 mr-2">
              {{ r.startTime.substring(0, 5) }} - {{ r.endTime.substring(0, 5) }}
            </div>
            <div class="text-body-2">
              {{ $t('TimeRuleHint') }}
            </div>
          </div>
        </v-card>
      </div>
    </loading-provider>
    <v-dialog
      v-model="showDialog"
      max-width="500"
    >
      <base-form
        :editing-object="editingObject"
        :schema="schemas"
        @close="showDialog=false"
        @submit="save"
      >
        {{ $t('AddEditTimeRule') }}
      </base-form>
    </v-dialog>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import PrimaryButton from '@/views/AadenPages/components/PrimaryButton.vue'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import { sureToDelete } from '@/model/utils/utils'
import {
  deleteSpecialClosingTime,
  getSpecialClosingTimes,
  saveSpecialClosingTime
} from '@/model/dataLayer/service/reservation/specialClosingTime'
import { VSelect } from 'vuetify/lib/components'
import TimeSelector from '@/views/AadenPages/settings/reserveSetting/openTime/TimeSelector.vue'
import DateSelector from '@/views/AadenPages/settings/reserveSetting/openTime/DateSelector.vue'
import sortBy from 'lodash-es/sortBy'
import dayjs from 'dayjs'
import { today } from '@/model/utils/DateRepository'

export default {
  name: 'SpecialClosingTime',
  components: {
    BaseForm,
    LoadingProvider,
    PrimaryButton,
    PageHeader
  },
  data: function () {
    return {
      showDialog: null,
      editingObject: null,
      list: [],
      loading: false
    }
  },
  computed: {
    schemas () {
      return [
        {
          key: 'date',
          component: DateSelector,
          componentProps: {
            min: today
          }
        },
        {
          key: 'startTime',
          component: TimeSelector
        },
        {
          key: 'endTime',
          component: TimeSelector
        },
        {
          key: 'active',
          name: 'isActive',
          component: VSelect,
          componentProps: {
            items: [
              { text: 'Yes', value: true },
              { text: 'No', value: false }
            ]
          },
          default: true
        }
      ]
    }
  },
  mounted () {
    this.reloadData()
  },
  methods: {
    edit (obj) {
      this.editingObject = obj
      this.editingObject.startTime = this.editingObject.startTime.slice(0, 5)
      this.editingObject.endTime = this.editingObject.endTime.slice(0, 5)
      this.showDialog = true
    },
    async remove (item) {
      await sureToDelete(async () => {
        await deleteSpecialClosingTime(item.id)
        await this.reloadData()
      })
    },
    async save (item) {
      await saveSpecialClosingTime(item)
      this.showDialog = false
      this.editingObject = null
      await this.reloadData()
    },

    async reloadData () {
      this.loading = true
      this.list = sortBy(await getSpecialClosingTimes(), 'date').filter(it => dayjs(it.date).isAfter(dayjs().subtract(1, 'day')))
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
